import merge from 'deepmerge';

function flatten(obj, results = []) {
  if (typeof(obj) === "object") {
    for (const val of Object.values(obj)) {
      flatten(val, results);
    }
  } else {
    results.push(obj);
  }

  return results;
}

export class AssetManager {
  constructor() {
    const assets = [
      require('./assets/**/*.jpg'),
      require('./assets/**/*.png'),
      require('./assets/**/*.gif'),
      require('./assets/**/*.mp4'),
      require('./assets/**/*.webm'),
      require('./assets/**/*.wav'),
      require('./assets/**/*.mp3'),
      require('./assets/**/*.ogg')
    ];

    this._assets = merge.all(assets);
    this._blobs = {};

    console.log('Assets', this._assets);
  }

  preload() {
    return Promise.all(flatten(this._assets).map(url => this.load(url)));
  }

  find(path) {
    if (path.length === 0) {
      return null;
    }

    path = [...path];

    let val = this._assets;
    while (path.length > 0) {
      const name = path.shift();
      if (val[name] === undefined) {
        return null;
      }

      val = val[name];
    }

    if (typeof(val) !== "string") {
      return null;
    }

    const type = val.split('.').pop();

    if (val in this._blobs) {
      val = this._blobs[val];
    }

    return { type, url: val };
  }

  async findAndLoad(path) {
    return this.load(this.find(path));
  }

  async load(url) {
    if (url in this._blobs) {
      return this._blobs[url];
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${url}`);
    }

    const blob = await response.blob();

    this._blobs[url] = URL.createObjectURL(blob);
    return blob;
  }
}